"use strict";

(function(){

var self = {

    /**
     * Запрос на сервер для авторасстановки/автозаполнения фото
     *
     * @param params
     */
    sendRequest: function(params){

        if (!$(".album-fotos .one-lines-items").find('.album_image').length) {
            Fotobook.notification.showWarning(t('photobook-js-messageSelectAlbum', {"message": ''}));
            return;
        }

        params.notUsedIDs = [];

        var $all_unused = $(".album-fotos .outer:not(.selected)"),
            $unused = $all_unused.find(".selectable:not(.no-original)").add($all_unused.find(".uploading")).find(".album_image:visible");

        $unused.each(function(){
            params.notUsedIDs.push(parseInt(this.getAttribute("data-id"), 10));
        });

        var $dialog = Fotobook.dialog.alert(t("photobook-js-autoFill") + ": " + Fotobook.projectChecking, {
            "title": t("photobook-js-autoFillDialogTitle"),
            "width": 400,
            "noClose": true,
            "showButtonResolve" : false,
        });

        Fotobook.ajax.postJSON('/editor/autofill/autofill', {
            "data": params,
        }).then((response) => {
            if (response.data.state) {
                Fotobook.book.pagesInit(response.data.state);
            } else if (response.data.containers) {
                for (var id in response.data.containers) {
                    if (response.data.containers.hasOwnProperty(id)) {
                        Fotobook.book.setContainerImage_response(response.data.containers[id]);
                    }
                }

                if (response.data.prices) {
                    Fotobook.book.prices = response.data.prices;
                }
            }
            Fotobook.isModified = true;
            if (response.data.message) {
                Fotobook.dialog.alert(response.data.message, {
                    "title": t('photobook-js-autofill-warningTitle'),
                    "fotobookDialogClass" : "autotest-autofill-dialog",
                    "noClose": true,
                    'width': 400,
                });
            }
            $(document).triggerHandler(Fotobook.events.PROJECT_CONTENT_CHANGED);
        }).catch(
            () => {}
        ).finally(() => Fotobook.dialog.close($dialog));
    },

    /**
     * Автозаполнение фотографиями
     *
     * @param params
     */
    autoFill: function(params){
        self.sendRequest($.extend(params || {}, {
            "method" : "autoFill",
        }));
    },

    /**
     * Авторасстановка (автомикс) фото
     *
     * @param params
     */
    autoMix: function(params){
        self.sendRequest($.extend(params || {}, {
            "method" : "autoFill",
        }));
    },

};

$(document)
.on("click", ".item-autofill", function(){
    const pages = $(Fotobook.book.pagesList).find('.book-page:not(.flyleaf-page)').map(function () {
        return Number($(this).attr('data-id'));
    }).toArray();
    self.autoFill({ pages });
})
.on("click", ".item-automix", function(){
    self.autoMix();
})
;

})();
